<template lang="html">
  <section class="techdata">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">

          <b-collapse id="techdata_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Country Id:</label>
                    <div class="col-lg-8">
                      <b-select v-model="selectedCountry">
                        <b-form-select-option :value="null">---</b-form-select-option>
                        <option v-for="country in countryList" :key="country.id" :value="country">
                          {{ country.id }} - {{ country.descEn }}
                        </option>
                      </b-select>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Model Id:</label>
                    <div class="col-lg-8">
                      <input type="text" class="col-lg-12" v-model="modelIdFilter" placeholder="Model Id" maxlength="7"/>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Model Year:</label>
                    <div class="col-lg-8">
                      <div class="row">
                        <div class="col-lg-2 pt-2">From</div>
                        <div class="col-lg-4">
                          <input type="text" class="col-lg-12" v-model="modelYearFromFilter" maxlength="4"/>
                        </div>

                        <div class="col-lg-2 pt-2">To</div>
                        <div class="col-lg-4">
                          <input type="text" class="col-lg-12" v-model="modelYearToFilter" maxlength="4"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Model Code:</label>
                    <div class="col-lg-8">
                      <input type="text" class="col-lg-12" v-model="modelCodeFilter" placeholder="Model Code" maxlength="15"/>
                    </div>
                  </div>
                </div>
              </div>
              <b-button variant="primary" v-b-toggle.techdata_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>

          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Techdata</h4>
            </div>

            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination align="fill" limit="6" v-model="currentPage" :total-rows="totalRowsResult" :per-page="perPage"
                  first-text="<<" prev-text="<" next-text=">" last-text=">>" ellipsisText="..." class="col-lg-10" ></b-pagination>
              </div>
            </div>

            <div class="col-lg-1">
              <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                <b-form-select-option value="5">5</b-form-select-option>
                <b-form-select-option value="10">10</b-form-select-option>
                <b-form-select-option value="20">20</b-form-select-option>
                <b-form-select-option value="50">50</b-form-select-option>
                <b-form-select-option value="100">100</b-form-select-option>
              </b-form-select>
            </div>

            <div class="col-lg-7">
              <span class="float-right">
                <b-button variant="primary mr-1" v-b-toggle.techdata_filters><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-techdata @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
              </span>
            </div>

            <b-table ref="techdata_tab" id="table" striped hover responsive :items="items" :fields="fields" :per-page="perPage"
              :current-page="1" primary-key="rowKey" no-local-sorting no-provider-paging sort-icon-left :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" >
              <template v-slot:cell(editButton)="data" lang="html">
                <b-button size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=copyItem(data.item)">
                  <i class="mdi mdi-pencil"></i>
                </b-button>
              </template>

              <template v-slot:cell(copyButton)="data" lang="html">
                <b-button size="sm" style="max-width: 2.875rem;" variant="secondary" @click="copyToNew(data.item)">
                  <i class="mdi mdi-content-copy"></i>
                </b-button>
              </template>

              <template v-slot:cell(deleteButton)="data" lang="html">
                <b-button size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                  <i class="mdi mdi-delete"></i>
                </b-button>
              </template>
              <template v-slot:cell(updateDate)="data">
                {{ formatDate(data.item.updateDate) }}
              </template>
            </b-table>

            <b-modal id="modal-edit" title="Edit Techdata" v-if="curItem" size="xl" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <h5 class="mb-3">Mandatory Data</h5>

                  <div class="mandatory-grid">
                    <div class="techdata-field-label">Country Id*:</div>
                      <b-form-select v-model="curItem.countryId" disabled>
                        <b-form-select-option
                          v-for="country in countryList"
                          :key="country.id"
                          :value="country.id"
                        >
                          {{ country.id }} - {{ country.descEn }}
                        </b-form-select-option>
                      </b-form-select>

                    <div class="techdata-field-label">Model Id*:</div>
                    <input type="text" v-model="curItem.modelId" maxlength="7" disabled/>

                    <div class="techdata-field-label">Model Code*:</div>
                    <input type="text" v-model="curItem.modelCode" maxlength="15" disabled/>

                    <div class="techdata-field-label">Family*:</div>
                    <input type="text" v-model="curItem.family" maxlength="15"/>

                    <div class="techdata-field-label">Model Year*:</div>
                    <input type="text" v-model="curItem.modelYear" maxlength="4"/>

                    <div class="techdata-field-label">Model Year Key*:</div>
                    <input type="text" v-model="curItem.myKey" maxlength="6"/>

                    <div class="techdata-field-label">Model Description*:</div>
                    <input
                      type="text"
                      class="model-description-full"
                      v-model="curItem.modelDescription"
                      maxlength="100"/>
                  </div>

                  <hr>
                <h5 class="mb-3">Tech Data</h5>
                <b-row v-for="triple in getTechDataFieldTriples()" :key="'edit-tech-' + triple[0].key" class="mb-2">
                  <div v-for="field in triple" :key="'edit-field-' + field.key" class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">{{ field.label }}:</div>
                    <input :type="field.type" class="col-lg-6" v-model="curItem[field.key]" :maxlength="field.maxLength" :max="field.max" :disabled="field.disabledEdit"/>
                  </div>
                </b-row>

                <hr>
                <h5 class="mb-3">Emission/Consumption Data</h5>
                <b-row v-for="triple in getEmissionFieldTriples()" :key="'edit-emission-' + triple[0].key" class="mb-2">
                  <div v-for="field in triple" :key="'edit-field-' + field.key" class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">{{ field.label }}:</div>
                    <input :type="field.type" class="col-lg-6" v-model="curItem[field.key]" :maxlength="field.maxLength" :max="field.max" :disabled="field.disabledEdit"/>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel }" lang="html">
                <fragment>
                  <b-button variant="secondary" @click="cancel()">Annulla</b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">Salva</b-button>
                </fragment>
              </template>
            </b-modal>

            <b-modal id="modal-new-techdata" title="New Techdata" size="xl" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <h5 class="mb-3">Mandatory Data</h5>

                  <div class="mandatory-grid">
                    <div class="techdata-field-label">Country Id*:</div>
                    <b-form-select v-model="newItem.countryId">
                      <b-form-select-option :value="null">
                        ---
                      </b-form-select-option>

                      <b-form-select-option
                        v-for="country in countryList"
                        :key="country.id"
                        :value="country.id"
                      >
                        {{ country.id }} - {{ country.descEn }}
                      </b-form-select-option>
                    </b-form-select>

                    <div class="techdata-field-label">Model Id*:</div>
                    <input type="text" v-model="newItem.modelId" maxlength="7"/>

                    <div class="techdata-field-label">Model Code*:</div>
                    <input type="text" v-model="newItem.modelCode" maxlength="15"/>

                    <div class="techdata-field-label">Family*:</div>
                    <input type="text" v-model="newItem.family" maxlength="15"/>

                    <div class="techdata-field-label">Model Year*:</div>
                    <input type="text" v-model="newItem.modelYear" maxlength="4"/>

                    <div class="techdata-field-label">Model Year Key*:</div>
                    <input type="text" v-model="newItem.myKey" maxlength="6"/>

                    <div class="techdata-field-label">Model Description*:</div>
                    <input
                      type="text"
                      class="model-description-full"
                      v-model="newItem.modelDescription"
                      maxlength="100"/>
                  </div>

                  <hr>

                <h5 class="mb-3">Tech Data</h5>
                <b-row v-for="triple in getTechDataFieldTriples()" :key="'new-tech-' + triple[0].key" class="mb-2">
                  <div v-for="field in triple" :key="'new-field-' + field.key" class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">{{ field.label }}:</div>
                    <input :type="field.type" class="col-lg-6" v-model="newItem[field.key]" :maxlength="field.maxLength" :max="field.max"/>
                  </div>
                </b-row>

                <hr>
                <h5 class="mb-3">Emission/Consumption Data</h5>
                <b-row v-for="triple in getEmissionFieldTriples()" :key="'new-emission-' + triple[0].key" class="mb-2">
                  <div v-for="field in triple" :key="'new-field-' + field.key" class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">{{ field.label }}:</div>
                    <input :type="field.type" class="col-lg-6" v-model="newItem[field.key]" :maxlength="field.maxLength" :max="field.max"/>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel }" lang="html">
                <fragment>
                  <b-button variant="secondary" @click="cancel()">Annulla</b-button>
                  <b-button variant="primary" @click="createItem()">Salva</b-button>
                </fragment>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
.techdata table td,
.techdata table th {
  text-align: left !important;
  vertical-align: top !important;
}
</style>

<script lang="js">
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'techdata',
  methods: {
    buildPayload(item) {
      let payload = Object.assign({}, item);
      payload.id = {
        countryId: item.countryId,
        modelId: item.modelId
      };
      payload.country = {
        id: item.countryId
      };
      return payload;
    },
    copyItem(item) {
      return Object.assign({}, item);
    },

    copyToNew(item) {
      this.newItem = this.copyItem(item);

      delete this.newItem.id;
      delete this.newItem.insertDate;
      delete this.newItem.insertUser;
      delete this.newItem.updateDate;
      delete this.newItem.updateUser;
      delete this.newItem.datetime;

      this.copiedCountryId = item.countryId;
      this.copiedModelId = item.modelId;

      this.$bvModal.show("modal-new-techdata");
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare ' + item.countryId + '/' + item.modelId + '?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.setSpinnerStatus(true);
          this.axios
            .delete('/ccb/auth/fe/masterTechdata/' + item.countryId + '/' + item.modelId, this.authHeader)
            .then(response => {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value => {
                this.refreshTable();
                this.curItem = null;
              })
            })
            .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              })
            }).finally(e => {
              this.setSpinnerStatus(false);
            })
        }
      })
    },
    saveCurItem(curItem) {
      let validationMessage = this.validateTechdataItem(curItem);
      if (validationMessage) {
        this.$bvModal.msgBoxOk(validationMessage, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
        return;
      }
      this.setSpinnerStatus(true);
      this.axios
        .put('/ccb/auth/fe/masterTechdata/' + curItem.countryId + '/' + curItem.modelId, this.buildPayload(curItem), this.authHeader)
        .then(response => {
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          }).then(value => {
            this.refreshTable();
          })
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e => {
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit');
        })
    },
    createItem() {
      if (this.copiedCountryId !== null
          && this.copiedModelId !== null
          && this.newItem.countryId == this.copiedCountryId
          && this.newItem.modelId == this.copiedModelId) {

        this.$bvModal.msgBoxOk(
          "To create a copy, you must change Country Id and Model Id before saving.",
          {
            okVariant: "warning",
            centered: true
          }
        );

        return;
      }
      let validationMessage = this.validateTechdataItem(this.newItem);
      if (validationMessage) {
        this.$bvModal.msgBoxOk(validationMessage, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      } else {
        this.setSpinnerStatus(true);
        this.axios
          .post('/ccb/auth/fe/masterTechdata', this.buildPayload(this.newItem), this.authHeader)
          .then(response => {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            }).then(value => {
              this.refreshTable();
            })
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e => {
            this.setSpinnerStatus(false);
            this.$bvModal.hide('modal-new-techdata');
          })
      }
    },
    search() {
      if (this.modelYearFromFilter && !/^\d{4}$/.test(this.modelYearFromFilter)) {
        this.$bvModal.msgBoxOk("Model Year From must be 4 digits", {
          okVariant: "danger",
          centered: true
        });
        return;
      }

      if (this.modelYearToFilter && !/^\d{4}$/.test(this.modelYearToFilter)) {
        this.$bvModal.msgBoxOk("Model Year To must be 4 digits", {
          okVariant: "danger",
          centered: true
        });
        return;
      }
      if (this.modelYearFromFilter &&
          this.modelYearToFilter &&
          Number(this.modelYearFromFilter) > Number(this.modelYearToFilter)) {

        this.$bvModal.msgBoxOk("Model Year From cannot be greater than Model Year To", {
          okVariant: "danger",
          centered: true
        });

        return;
      }
      this.setLastSearch(this.search);
      this.setSpinnerStatus(true);

      let params = {
        countryId: this.selectedCountry ? this.selectedCountry.id : null,
        modelId: this.modelIdFilter ? this.modelIdFilter : null,
        modelYearFrom: this.modelYearFromFilter ? this.modelYearFromFilter : null,
        modelYearTo: this.modelYearToFilter ? this.modelYearToFilter : null,
        modelCode: this.modelCodeFilter,
        page: this.currentPage - 1,
        size: this.perPage,
        sortBy: this.sortBy === 'modelId' ? 'id.modelId'
        : this.sortBy === 'countryId' ? 'id.countryId'
        : this.sortBy,
        sortDesc: this.sortDesc
      };

      this.axios
        .get('/ccb/auth/fe/masterTechdata/allPaged', {
          params: params,
          ...this.authHeader
        })
        .then((response) => {
          this.itemsData = response.data.content.map(item => {
          return {
            ...item,
            rowKey: item.countryId + '-' + item.modelId
          };
        });
          this.totalRowsResult = response.data.totalElements;
        })
        .finally(e => {
          this.setSpinnerStatus(false);
        });
    },
    btnNew() {
      this.copiedCountryId = null;
      this.copiedModelId = null;
      this.newItem = {
        countryId: null,
        modelId: null,
        modelCode: null,
        modelDescription: null,
        modelYear: null
      };
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setSpinnerStatus',
      'setLastSearch'
    ]),
    getTriples(fields) {
      let triples = [];
      for (let i = 0; i < fields.length; i += 3) {
        triples.push(fields.slice(i, i + 3));
      }
      return triples;
    },
    getMandatoryFieldTriples() {
      return this.getTriples(this.formFields.filter(field =>
        ['countryId', 'modelId', 'modelYear', 'modelCode', 'modelDescription', 'family', 'myKey'].includes(field.key)
      ));
    },
    getTechDataFieldTriples() {
      let mandatoryKeys = ['countryId', 'modelId', 'modelYear', 'modelCode', 'modelDescription', 'family', 'myKey'];
      let efficiencyIndex = this.formFields.findIndex(field => field.key === 'efficiencyClass');

      return this.getTriples(this.formFields
        .slice(0, efficiencyIndex + 1)
        .filter(field => !mandatoryKeys.includes(field.key))
      );
    },
    getEmissionFieldTriples() {
      let efficiencyIndex = this.formFields.findIndex(field => field.key === 'efficiencyClass');
      return this.getTriples(this.formFields.slice(efficiencyIndex + 1));
    },
    validateTechdataItem(item) {
      if (item.countryId === null || item.countryId === undefined || item.countryId === ''
          || item.modelId === null || item.modelId === undefined || item.modelId === ''
          || item.modelYear === null || item.modelYear === undefined || item.modelYear === ''
          || !item.modelCode
          || !item.modelDescription
          || !item.family
          || !item.myKey) {
        return "Inserisci tutti i campi obbligatori";
      }

      if (Number(item.modelYear) < 1000 || Number(item.modelYear) > 9999) {
        return "Model Year must be 4 digits";
      }

      if (item.modelCode.length > 15) {
        return "Model Code must be max 15 characters";
      }

      if (item.modelDescription.length > 100) {
        return "Model Description must be max 100 characters";
      }

      if (item.family.length > 15) {
        return "Family must be max 15 characters";
      }

      if (item.myKey.length > 6) {
        return "Model Year Key must be max 6 characters";
      }

      return null;
    },
    formatDate(value) {
      if (!value) {
        return '';
      }

      return new Date(value).toLocaleString('it-IT');
    },
    loadCountries() {
      this.axios
        .get('/ccb/auth/fe/country/listCountryView', this.authHeader)
        .then(response => {
          this.countryList = [
            {
              id: 0,
              descEn: "All Countries"
            },
            ...response.data
          ];
        });
    }
  },
  data () {
    return {
      totalRowsResult: 0,
      currentPage: 1,
      perPage: 10,
      sortBy: 'modelCode',
      sortDesc: false,
      curItem: null,
      newItem: {},
      copiedCountryId: null,
      copiedModelId: null,
      itemsData: [],
      selectedCountry: null,
      countryList: [],
      fields: [
        { key: 'countryId', label: 'Country Id', sortable: true },
        { key: 'modelId', label: 'Model Id', sortable: true },
        { key: 'modelYear', label: 'Model Year', sortable: true },
        { key: 'modelCode', label: 'Model Code', sortable: true },
        { key: 'modelDescription', label: 'Model Description', sortable: false },
        { key: 'updateDate', label: 'Update Date', sortable: true },
        { key: 'updateUser', label: 'Update User', sortable: true },
        { key: 'editButton', label: 'Edit', sortable: false },
        { key: 'copyButton', label: 'Copy', sortable: false },
        { key: 'deleteButton', label: 'Delete', sortable: false }
      ],
      formFields: [
        { key: 'countryId', label: 'Country Id*', type: 'text', maxLength: 3, disabledEdit: true },
        { key: 'modelId', label: 'Model Id*', type: 'text', maxLength: 7, disabledEdit: true },
        { key: 'modelYear', label: 'Model Year*', type: 'text', maxLength: 4 },
        { key: 'modelCode', label: 'Model Code*', type: 'text', maxLength: 15 },
        { key: 'modelDescription', label: 'Model Description*', type: 'text', maxLength: 100 },
        { key: 'variant', label: 'Variant', type: 'text', maxLength: 30 },
        { key: 'modelType', label: 'Model Type', type: 'text', maxLength: 30 },
        { key: 'family', label: 'Family*', type: 'text', maxLength: 15 },
        { key: 'engineGroup', label: 'Engine Group', type: 'text', maxLength: 50 },
        { key: 'trim', label: 'Trim', type: 'text', maxLength: 50 },
        { key: 'myKey', label: 'Model Year Key*', type: 'text', maxLength: 6 },
        { key: 'modelYearDescr', label: 'Model Year Description', type: 'text', maxLength: 50 },
        { key: 'versionGroup', label: 'Version Group', type: 'text', maxLength: 30 },
        { key: 'engineLayout', label: 'Engine Layout', type: 'text', maxLength: 1, width: 'col-lg-2' },
        { key: 'nCylinders', label: 'Cylinders Number', type: 'number', max: 99, width: 'col-lg-2' },
        { key: 'nGears', label: 'Gears Number', type: 'number', max: 99, width: 'col-lg-2' },
        { key: 'displacementCc', label: 'Displacement (cc)', type: 'text', maxLength: 10 },
        { key: 'displacementLt', label: 'Displacement (l)', type: 'text', maxLength: 10 },
        { key: 'maxPowerKw', label: 'Max Power (kW)', type: 'text', maxLength: 10 },
        { key: 'maxPowerHp', label: 'Max Power (HP)', type: 'text', maxLength: 10 },
        { key: 'maxPowerBhp', label: 'Max Power (BHP)', type: 'text', maxLength: 10 },
        { key: 'maxPowerRpmrange', label: 'Max Power RPM Range', type: 'text', maxLength: 10 },
        { key: 'maxTorqueNewtonm', label: 'Max Torque (Nm)', type: 'text', maxLength: 10 },
        { key: 'maxTorqueRpmrange', label: 'Max Torque RPM Range', type: 'text', maxLength: 10 },
        { key: 'maxSpeedKmh', label: 'Max Speed (km/h)', type: 'text', maxLength: 10 },
        { key: 'maxSpeedMph', label: 'Max Speed (mph)', type: 'text', maxLength: 10 },
        { key: 'acceleration0100kmhSec', label: '0-100 km/h Acceleration (s)', type: 'text', maxLength: 10 },
        { key: 'acceleration060mphSec', label: '0-60 mph Acceleration (s)', type: 'text', maxLength: 10 },
        { key: 'consumptionCombinedL100km', label: 'Combined Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'consumptionUrbanL100km', label: 'Urban Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'consumptionExtraL100km', label: 'Extra Urban Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'consumptionJpJc08Kml', label: 'JC08 Consumption (km/l)', type: 'text', maxLength: 20 },
        { key: 'emissionsCombinedGkm', label: 'Combined Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'emissionsUrbanGkm', label: 'Urban Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'emissionsExtraGkm', label: 'Extra Urban Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'consumptionCombinedMpg', label: 'Combined Consumption (mpg)', type: 'text', maxLength: 20 },
        { key: 'consumptionUrbanMpg', label: 'Urban Consumption (mpg)', type: 'text', maxLength: 20 },
        { key: 'consumptionExtraMpg', label: 'Extra Urban Consumption (mpg)', type: 'text', maxLength: 20 },
        { key: 'transmission', label: 'Transmission', type: 'text', maxLength: 20 },
        { key: 'tyresFront', label: 'Front Tyres', type: 'text', maxLength: 30 },
        { key: 'tyresRear', label: 'Rear Tyres', type: 'text', maxLength: 30 },
        { key: 'lengthMm', label: 'Length (mm)', type: 'text', maxLength: 10 },
        { key: 'lengthIn', label: 'Length (in)', type: 'text', maxLength: 10 },
        { key: 'widthWithMirrorsMm', label: 'Width with Mirrors (mm)', type: 'text', maxLength: 10 },
        { key: 'widthWithMirrorsIn', label: 'Width with Mirrors (in)', type: 'text', maxLength: 10 },
        { key: 'widthNoMirrorsMm', label: 'Width without Mirrors (mm)', type: 'text', maxLength: 10 },
        { key: 'widthNoMirrorsIn', label: 'Width without Mirrors (in)', type: 'text', maxLength: 10 },
        { key: 'heightMm', label: 'Height (mm)', type: 'text', maxLength: 10 },
        { key: 'heightIn', label: 'Height (in)', type: 'text', maxLength: 10 },
        { key: 'wheelbaseMm', label: 'Wheelbase (mm)', type: 'text', maxLength: 10 },
        { key: 'wheelbaseIn', label: 'Wheelbase (in)', type: 'text', maxLength: 10 },
        { key: 'frontTrackMm', label: 'Front Track (mm)', type: 'text', maxLength: 10 },
        { key: 'frontTrackIn', label: 'Front Track (in)', type: 'text', maxLength: 10 },
        { key: 'rearTrackMm', label: 'Rear Track (mm)', type: 'text', maxLength: 10 },
        { key: 'rearTrackIn', label: 'Rear Track (in)', type: 'text', maxLength: 10 },
        { key: 'frontOverhangMm', label: 'Front Overhang (mm)', type: 'text', maxLength: 10 },
        { key: 'frontOverhangIn', label: 'Front Overhang (in)', type: 'text', maxLength: 10 },
        { key: 'rearOverhangMm', label: 'Rear Overhang (mm)', type: 'text', maxLength: 10 },
        { key: 'rearOverhangIn', label: 'Rear Overhang (in)', type: 'text', maxLength: 10 },
        { key: 'turningCircleMm', label: 'Turning Circle (mm)', type: 'text', maxLength: 10 },
        { key: 'turningCircleIn', label: 'Turning Circle (in)', type: 'text', maxLength: 10 },
        { key: 'bootCapacityL', label: 'Boot Capacity (l)', type: 'text', maxLength: 10 },
        { key: 'bootCapacityFt', label: 'Boot Capacity (ft³)', type: 'text', maxLength: 10 },
        { key: 'fuelTankCapacityL', label: 'Fuel Tank Capacity (l)', type: 'text', maxLength: 10 },
        { key: 'fuelTankCapacityGal', label: 'Fuel Tank Capacity (gal)', type: 'text', maxLength: 10 },
        { key: 'kerbWeightKg', label: 'Kerb Weight (kg)', type: 'text', maxLength: 20 },
        { key: 'kerbWeightLb', label: 'Kerb Weight (lb)', type: 'text', maxLength: 20 },
        { key: 'unladenWeightKg', label: 'Unladen Weight (kg)', type: 'text', maxLength: 20 },
        { key: 'unladenWeightLb', label: 'Unladen Weight (lb)', type: 'text', maxLength: 20 },
        { key: 'grossWeightKg', label: 'Gross Weight (kg)', type: 'text', maxLength: 20 },
        { key: 'grossWeightLb', label: 'Gross Weight (lb)', type: 'text', maxLength: 20 },
        { key: 'boreMm', label: 'Bore (mm)', type: 'text', maxLength: 10 },
        { key: 'boreIn', label: 'Bore (in)', type: 'text', maxLength: 10 },
        { key: 'strokeMm', label: 'Stroke (mm)', type: 'text', maxLength: 10 },
        { key: 'strokeIn', label: 'Stroke (in)', type: 'text', maxLength: 10 },
        { key: 'compressionRatio', label: 'Compression Ratio', type: 'text', maxLength: 30 },
        { key: 'traction', label: 'Traction', type: 'text', maxLength: 30 },
        { key: 'efficiencyClass', label: 'Efficiency Class', type: 'text', maxLength: 10, width: 'col-lg-2' },
        { key: 'emissionCertificationEu', label: 'EU Emission Certification', type: 'text', maxLength: 20 },
        { key: 'fuelType', label: 'Fuel Type', type: 'text', maxLength: 2, width: 'col-lg-2' },
        { key: 'stopDistFrom100To0kmhM', label: 'Braking Distance 100-0 km/h (m)', type: 'text', maxLength: 10 },
        { key: 'stopDistFrom100To0kmhFt', label: 'Braking Distance 100-0 km/h (ft)', type: 'text', maxLength: 10 },
        { key: 'stopDistFrom60To0mphM', label: 'Braking Distance 60-0 mph (m)', type: 'text', maxLength: 10 },
        { key: 'stopDistFrom60To0mphFt', label: 'Braking Distance 60-0 mph (ft)', type: 'text', maxLength: 10 },
        { key: 'maxTorqueBoostNewtonm', label: 'Max Torque Boost (Nm)', type: 'text', maxLength: 10 },
        { key: 'maxTorqueBoostRpmrange', label: 'Max Torque Boost RPM Range', type: 'text', maxLength: 10 },
        { key: 'maxTorqueFtLb', label: 'Max Torque (ft-lb)', type: 'text', maxLength: 10 },
        { key: 'consumptionCombMpgUk', label: 'Combined Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'consumptionUrbanMpgUk', label: 'Urban Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'consumptionExtraMpgUk', label: 'Extra Urban Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'nedcEmisExtraGkm', label: 'NEDC Extra Urban Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'nedcEmisCombGkm', label: 'NEDC Combined Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'nedcEmisWeightCombGkm', label: 'NEDC Weighted Combined Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'nedcEmisUrbanGkm', label: 'NEDC Urban Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'nedcConsExtraL100km', label: 'NEDC Extra Urban Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'nedcConsCombL100km', label: 'NEDC Combined Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'nedcConsWeightCombL100km', label: 'NEDC Weighted Combined Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'nedcConsUrbanL100km', label: 'NEDC Urban Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'wltpEmisLowGkm', label: 'WLTP Low Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'wltpEmisMediumGkm', label: 'WLTP Medium Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'wltpEmisHighGkm', label: 'WLTP High Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'wltpEmisExtraHighGkm', label: 'WLTP Extra High Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'wltpEmisCombGkm', label: 'WLTP Combined Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'wltpEmisWeightCombGkm', label: 'WLTP Weighted Combined Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'wltpConsLowL100km', label: 'WLTP Low Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'wltpConsMediumL100km', label: 'WLTP Medium Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'wltpConsHighL100km', label: 'WLTP High Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'wltpConsExtraHighL100km', label: 'WLTP Extra High Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'wltpConsCombL100km', label: 'WLTP Combined Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'wltpConsWeightCombL100km', label: 'WLTP Weighted Combined Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'consLowMpgWltpUk', label: 'WLTP Low Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'consMediumMpgWltpUk', label: 'WLTP Medium Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'consHighMpgWltpUk', label: 'WLTP High Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'consExtraHighMpgWltpUk', label: 'WLTP Extra High Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'consCombinedMpgWltpUk', label: 'WLTP Combined Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'consWCombinedMpgWltpUk', label: 'WLTP Weighted Combined Consumption UK (mpg)', type: 'text', maxLength: 20 },
        { key: 'homologatedWeightKg', label: 'Homologated Weight (kg)', type: 'text', maxLength: 20 },
        { key: 'homologatedWeightLb', label: 'Homologated Weight (lb)', type: 'text', maxLength: 20 },
        { key: 'midWeightKg', label: 'Mid Weight (kg)', type: 'text', maxLength: 20 },
        { key: 'midWeightLb', label: 'Mid Weight (lb)', type: 'text', maxLength: 20 },
        { key: 'consumptionCombinedKml', label: 'Combined Consumption (km/l)', type: 'text', maxLength: 20 },
        { key: 'consumptionUrbanKml', label: 'Urban Consumption (km/l)', type: 'text', maxLength: 20 },
        { key: 'consumptionExtraKml', label: 'Extra Urban Consumption (km/l)', type: 'text', maxLength: 20 },
        { key: 'bevBatteryCapacityKwh', label: 'BEV Battery Capacity (kWh)', type: 'text', maxLength: 20 },
        { key: 'rangeKm', label: 'Range (km)', type: 'text', maxLength: 20 },
        { key: 'rangeMiles', label: 'Range (miles)', type: 'text', maxLength: 20 },
        { key: 'rechargePowerAc', label: 'AC Recharge Power', type: 'text', maxLength: 20 },
        { key: 'rechargePowerDc', label: 'DC Recharge Power', type: 'text', maxLength: 20 },
        { key: 'wltpConsLowBev', label: 'WLTP Low Consumption BEV', type: 'text', maxLength: 20 },
        { key: 'wltpConsMediumBev', label: 'WLTP Medium Consumption BEV', type: 'text', maxLength: 20 },
        { key: 'wltpConsHighBev', label: 'WLTP High Consumption BEV', type: 'text', maxLength: 20 },
        { key: 'wltpConsExtraHighBev', label: 'WLTP Extra High Consumption BEV', type: 'text', maxLength: 20 },
        { key: 'wltpConsCombBev', label: 'WLTP Combined Consumption BEV', type: 'text', maxLength: 20 },
        { key: 'wltpConsWeightCombBev', label: 'WLTP Weighted Combined Consumption BEV', type: 'text', maxLength: 20 },
        { key: 'wltpEmisLowBev', label: 'WLTP Low Emissions BEV', type: 'text', maxLength: 20 },
        { key: 'wltpEmisMediumBev', label: 'WLTP Medium Emissions BEV', type: 'text', maxLength: 20 },
        { key: 'wltpEmisHighBev', label: 'WLTP High Emissions BEV', type: 'text', maxLength: 20 },
        { key: 'wltpEmisExtraHighBev', label: 'WLTP Extra High Emissions BEV', type: 'text', maxLength: 20 },
        { key: 'wltpEmisCombBev', label: 'WLTP Combined Emissions BEV', type: 'text', maxLength: 20 },
        { key: 'wltpEmisWeightCombBev', label: 'WLTP Weighted Combined Emissions BEV', type: 'text', maxLength: 20 }
      ],
      modelIdFilter: '',
      modelYearFromFilter: '',
      modelYearToFilter: '',
      modelCodeFilter: ''
    }
  },
  computed: {
    items () {
      return this.itemsData ? this.itemsData : [];
    },
    ...mapGetters([
      'authHeader',
      'getCurUser'
    ])
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.refreshTable();
    },
    perPage(newValue, oldValue) {
      this.refreshTable();
    },
    sortBy(newValue, oldValue) {
      this.refreshTable();
    },
    sortDesc(newValue, oldValue) {
      this.refreshTable();
    }
  },
  mounted() {
    this.setCurApp('ccadm');
    this.loadCountries();
    this.search();
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}

::v-deep .modal-dialog {
  max-width: 1400px;
}
::v-deep .mandatory-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  row-gap: 10px;
  align-items: center;
  margin-left: -15px;
  margin-right: -15px;
  margin-bottom: 1rem;
}

::v-deep .mandatory-grid > .techdata-field-label,
::v-deep .mandatory-grid > input {
  padding-left: 15px;
  padding-right: 15px;
}

::v-deep .mandatory-grid > input {
  width: 95%;
  height: 34px;
  box-sizing: border-box;
}

::v-deep .mandatory-grid > input.model-description-full {
  grid-column: 2 / 7;
  width: 99% !important;
  justify-self: start;
}
</style>